import instance from "../Config/axios";

/* -------------------------------------------------------------------------------------------------
loginUser: logins an user.
--------------------------------------------------------------------------------------------------*/
                                                                                // login user
export async function loginUser(user){
    
    var query = {
        status:'error',
        msg:"Credenciales no válidas"
    };
    try{
        await instance.post(  `/user.php?login`, user)
        .then(res => {
            if( res.status === 200  ){
                query.status = 'OK';
                query.msg = res.data.message;
            }
        }).catch(function (error) {
            if(error.response.data.message)query.msg = error.response.data.message;
          });
    }catch(e){
        query.msg = "Se produjo un error en la solicitud.";
    }
    console.log( query )
    return query
}

/* -------------------------------------------------------------------------------------------------
getUserData:
--------------------------------------------------------------------------------------------------*/
                                                                                // login user
export async function getUserData(){
    
    var query = {
        status:'error',
        msg:"Token no válido"
    };
    try{
        await instance.get(  `/user.php?user_info`)
        .then(res => {
            if( res.status === 200  ){
                query.status = 'OK';
                query.msg = res.data.user_data;
            }
        }).catch(function (error) {
            if(error.response.data.message)query.msg = error.response.data.message;
          });
    }catch(e){
        query.msg = "Se produjo un error en la solicitud.";
    }
    console.log( query )
    return query
}


/* -------------------------------------------------------------------------------------------------
getRoles:
--------------------------------------------------------------------------------------------------*/
                                                                                // login user
export async function getRoles()
{
    
    var query = {
        status:'error',
        msg:"Token no válido"
    };
    try{
        await instance.get(  `/user.php?roles`)
        .then(res => {
            console.log( res )
            if( res.status === 200  ){
                query.status = 'OK';
                query.msg = res.data.data.roles;
            }
        }).catch(function (error) {
            if(error.response.data.message)query.msg = error.response.data.message;
          });
    }catch(e){
        query.msg = "Se produjo un error en la solicitud.";
    }
    console.log( query )
    return query
}


/* -------------------------------------------------------------------------------------------------
getUsers:
/services/api/user.php?view&from=[PAGE_FROM]&regs=[REGS_FOR_PAGE]
--------------------------------------------------------------------------------------------------*/
                                                                                // login user
export async function getUsers( data )
{
    
    var query = {
        status:'error',
        msg:"Token no válido"
    };
    try{
        await instance.get(  `/user.php?view&from=`+data.from+`&regs=`+data.regs)
        .then(res => {
            //console.log( res );
            if( res.status === 200  ){
                query.status = 'OK';
                query.msg = res.data.data;
            }
        }).catch(function (error) {
            if(error.response.data.message)query.msg = error.response.data.message;
          });
    }catch(e){
        query.msg = "Se produjo un error en la solicitud.";
    }
    console.log( query )
    return query
}



/* -------------------------------------------------------------------------------------------------
findUsersService:
/services/api/user.php?view&from=[PAGE_FROM]&regs=[REGS_FOR_PAGE]
--------------------------------------------------------------------------------------------------*/
                                                                                // login user
export async function findUsersService( data )
{
    
    var query = {
        status:'error',
        msg:"Token no válido"
    };
    try{
        await instance.get(  `/user.php?find&data=`+data.data+'&from='+data.from+'&regs='+data.regs)
        .then(res => {
            //console.log( res );
            if( res.status === 200  ){
                query.status = 'OK';
                query.msg = res.data.data;
            }
        }).catch(function (error) {
            if(error.response.data.message)query.msg = error.response.data.message;
          });
    }catch(e){
        query.msg = "Se produjo un error en la solicitud.";
    }
    console.log( query )
    return query
}


/* -------------------------------------------------------------------------------------------------
deleteUser:
--------------------------------------------------------------------------------------------------*/
           
export async function deleteUser( data )
{
    
    var query = {
        status:'error',
        msg:"Token no válido"
    };
    try{
        await instance.delete(  `/user.php?deleteuser&user=`+data)
        .then(res => {
            //console.log( res );
            if( res.status === 200  ){
                query.status = 'OK';
                query.msg = res.data.data;
            }
        }).catch(function (error) {
            if(error.response.data.message)query.msg = error.response.data.message;
          });
    }catch(e){
        query.msg = "Se produjo un error en la solicitud.";
    }
    console.log( query )
    return query
}


/* -------------------------------------------------------------------------------------------------
updateUser:
--------------------------------------------------------------------------------------------------*/
                                                                                
export async function updateUser(data){
    
    var query = {
        status:'error',
        close_session:true,
        msg:"Se produjo un error."
    };
    try{
        let req = `/user.php?updateuser`;
        await instance.put(  req, data )
        .then(res => {
            console.log( res )
            if( res.status === 200  ){
                query.status = 'OK';
                query.msg = res.data.data;
            }
        }).catch(function (error) {
            if( error.response.status === 400 )query.close_session = false;
            if( error.response.data.message)query.msg = error.response.data.message;
          });
    }catch(e){
        query.msg = "Se produjo un error en la solicitud.";
    }
    console.log( query )
    return query
}



/* -------------------------------------------------------------------------------------------------
newUser:
--------------------------------------------------------------------------------------------------*/
                                                                                
export async function newUser(data){
    
    var query = {
        status:'error',
        close_session:true,
        msg:"Se produjo un error."
    };
    try{
        let req = `/user.php?newuser`;
        await instance.post(  req, data )
        .then(res => {
            console.log( res )
            if( res.status === 200  ){
                query.status = 'OK';
                query.msg = res.data.data;
            }
        }).catch(function (error) {
            if( error.response.status === 400 )query.close_session = false;
            if( error.response.data.message)query.msg = error.response.data.message;
          });
    }catch(e){
        query.msg = "Se produjo un error en la solicitud.";
    }
    console.log( query )
    return query
}